import { IPagedFilterRequest } from "../interfaces/IPagedFilterResults";

export function buildPagedFilterQuery(request: IPagedFilterRequest): string {
  const params = new URLSearchParams();

  if (request.page != null) {
    params.append("page", request.page.toString());
  }

  if (request.pageSize != null) {
    params.append("pageSize", request.pageSize.toString());
  }

  if (request.sortBy) {
    params.append("sortBy", request.sortBy);
  }

  if (request.sortDesc != null) {
    params.append("sortDesc", request.sortDesc.toString());
  }

  if (request.filters) {
    Object.entries(request.filters).forEach(([key, value]) => {
     if (value !== undefined && value !== null && value !== '') {
                params.append(`filters[${key}]`, value);
            }
    });
  }

  return params.toString();
}
